import { Component, Input, EventEmitter, Output } from '@angular/core';

import {
    HisNotificationService,
    HisUiService, GenericValue
} from 'hisng';

import { OrganizationService } from 'app/fs/res/common/service/organization/organization.service';

@Component( {
    selector: 'res-historized-organization-edit',
    templateUrl: './historized-organization-edit.component.html',
} )
export class HistorizedOrganizationEditComponent {
    organizations: GenericValue[]; // ngModel
    @Input( 'organizations' ) set _organisations( organizations: GenericValue[] ) {
        console.log( 'set organizations =', organizations );
        this.organizations = organizations;
    }

    @Input() isAddOrganization: boolean;
    @Input() ddKey = 'fs.res.common.organizations.historized';
    @Input() showSelectionBelow = true;
    @Input() clearAfterSelection = false;

    @Output() selectedHistorizedOrgUnitChange: EventEmitter<GenericValue[]> = new EventEmitter();

    public filteredOptions: GenericValue[];
    public selectedOrganization: GenericValue;

    constructor( private notificationService: HisNotificationService,
        private hisUiService: HisUiService,
        private organizationService: OrganizationService ) {
    }

    /* auto-complete field functions */

    /**
     * completeMethod() implementation of <p-autoComplete> to filter inputs.
     *
     * @param event Event contains the autocomplete input field value
     */
    completeMethod( event: { query: string } ) {
        this.organizationService.getHistorized( event.query ).subscribe(
            ( organizationsValues: GenericValue[] ) => {
                this.filteredOptions = organizationsValues.sort(
                    ( a: GenericValue, b: GenericValue ) =>
                        a.text.toLowerCase().localeCompare(b.text.toLowerCase()));
            } );
    }

    /**
     * implementation of <p-autoComplete> to add an organization.
     *
     * @param event GenericValue selected value of <p-autoComplete>
     */
    onSelect( event: GenericValue ) {
        let organizationUnit: GenericValue = event;
        if ( this.organizations.find( o => o.id === organizationUnit.id ) ) {
            this.notificationService.warnI18nRes( 'fs.res.common.organizations.alreadyAssigned' );
            // bei Warnmeldung das input-Feld nicht löschen, damit man noch weiss worum es ging
        } else {
            this.organizations.push( organizationUnit );
            this.selectedHistorizedOrgUnitChange.emit( this.organizations );
            // Input-Feld löschen
            // #296767 timeout scheint notwendig, damit des Eingabefeld auch bei der 2. und 3. Auswahl wieder gelöscht wird...
            if (this.clearAfterSelection) {
                setTimeout(() => {
                    this.selectedOrganization = null;
                    return;
                });
            }
        }
    }

    /**
     * delete historized organization from table
     *
     * @param row historized organization to delete, represented as GenericValue
     */
    deleteOrganization( row: GenericValue ) {
        alert( 'Löschen ist noch nicht implementiert, ' + row.defaulttext + ' kann nicht gelöscht werden.' );
        // TODO
    }
}
